import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "src/redux/store";

type AdminGuestGuardProps = {
  children: React.ReactNode;
};

export default function AdminGuestGuard({ children }: AdminGuestGuardProps) {
  const adminAuth = useSelector((state: RootState) => state.adminAuth);

  if (adminAuth.accessToken) {
    return <Navigate to="/admin/dashboard" replace />;
  }

  return <>{children}</>;
}
